import { IGetArqDisciplinaChecklistUseCase } from "../../../presentation/useCases/read/get_arq_disciplina_checklist_use_case";
import { UpdateDisciplinaChecklistRequestModel } from "../../models/disciplina_item_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class GetArqDisciplinaChecklistUseCase implements IGetArqDisciplinaChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getArqDisciplinaChecklist(model: UpdateDisciplinaChecklistRequestModel): Promise<void> {
    const blob = await this.repository.getArqDisciplinaChecklist(model);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(model.nomearquivo1)); 
    document.body.appendChild(link);
    link.click(); 
    
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
